import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface ReadOnlyContainerProps {
    minHeight?: string
    flexAlign?: 'flex-start' | 'flex-end' | 'center'
}
export const ReadOnlyContainer = styled.div<ReadOnlyContainerProps>`
    width: 100%;
    min-width: 120px;
    max-width: 546px;
    svg {
        margin-right: 12px;
    }
    padding: 0 12px;
    display: flex;
    align-items: ${({ flexAlign }) => (flexAlign ? flexAlign : 'center')};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : '38px')};
    border-left: 1px solid ${theme.newColors.neutral200};
    border-radius: 4px;
`
